import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { twMerge } from 'tailwind-merge';
import { Text } from '../../atoms/Text';
import { useTestId } from '../../hooks';
import { forwardRefWithName } from '../../utils';
function TagComponent(_a, ref) {
    var { children, className, theme = 'default', size = 'small', testId = 'tag' } = _a, props = __rest(_a, ["children", "className", "theme", "size", "testId"]);
    const tid = useTestId(testId, props);
    const classList = twMerge('rounded-sm', 'inline-flex', 'select-none', 'whitespace-nowrap', `tag-${theme}`, `tag-${size}`, className);
    return (_jsx("div", Object.assign({ ref: ref, className: classList }, props, tid(), { children: _jsx(Text, Object.assign({ variant: size === 'small' ? 'captionTitleSmall' : 'captionTitle' }, tid('content'), { children: children })) })));
}
export const Tag = forwardRefWithName(TagComponent);
//# sourceMappingURL=Tag.js.map